import React from "react";
import classNames from 'classnames';
import { Edit, Email } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import cn from "./SalesAgencyRow.module.css";

export function SalesAgencyRow({ agency, showEditIcon, showEmailIcon, highlighted = false }) {
  const handleEditClick = (event) => {
    event.stopPropagation();
    window.location.href = `/apasi-profile/?agency_nonce=${agency.agency_nonce}`;
  };

  return (
    <div className={cn.row}>
      <div className={classNames(cn.rowItem, {[cn.highlighted]: highlighted })}>
        {agency.first_name} {agency.last_name} ({agency.apasi_user_asafid ? agency.apasi_user_asafid : 'Unknown'})
      </div>
      {showEditIcon && (
        <IconButton onClick={handleEditClick} color="primary" className={cn.button}>
          <Edit color="primary" className={cn.rowItem} />
        </IconButton>
      )}
      {showEmailIcon && (
        <div className="apasi_agency_welcome_email" data-agency-nonce={agency.agency_nonce}>
          <IconButton color="primary" className={cn.button}>
            <Email color="primary" />
          </IconButton>
        </div>
      )}
    </div>
  );
}
